import clsx from "clsx";
import { normalizeParamName } from "../lib/params.js";

export const buildName = (...parts: (string | number | null | undefined)[]) => {
  return parts
    .filter((x) => x != null)
    .map((name) => normalizeParamName(String(name)))
    .join(".");
};

export const getNestedIndexClassName = (_nestedIndex: number) => {
  return clsx("rounded-lg border border-primary bg-contrast-light/5 p-3");
};
